/**
 * 大会モード関連の型定義
 */
import { BattleResultType } from './BattleState';
import { AILevel, AIConfig } from '../ai/types';

/** 大会の種類 */
export enum TournamentMode {
  /** 総当たり戦（ラウンドロビン） */
  ROUND_ROBIN = 'ROUND_ROBIN',
  /** トーナメント戦（シングルエリミネーション） */
  SINGLE_ELIMINATION = 'SINGLE_ELIMINATION',
}

/** 大会の進行状態 */
export enum TournamentPhase {
  /** 未開始 */
  NOT_STARTED = 'NOT_STARTED',
  /** 進行中 */
  IN_PROGRESS = 'IN_PROGRESS',
  /** 終了 */
  FINISHED = 'FINISHED',
}

/** 大会参加者 */
export interface TournamentParticipant {
  /** 参加者ID（'player' or 'cpu-{monsterId}'） */
  id: string;
  /** モンスターID */
  monsterId: string;
  /** プレイヤーかどうか */
  isPlayer: boolean;
  /** 勝利数 */
  wins: number;
  /** 敗北数 */
  losses: number;
  /** 引き分け数 */
  draws: number;
  /** 勝ち点（勝3, 分1, 負0） */
  points: number;
  /** カスタムAI設定（プレイヤーがカスタムAIを使用する場合のみ設定） */
  aiConfig?: AIConfig;
}

/** 試合結果 */
export interface TournamentMatchResult {
  /** 勝者の参加者ID（ドローの場合null） */
  winnerId: string | null;
  /** 敗者の参加者ID（ドローの場合null） */
  loserId: string | null;
  /** バトル結果タイプ */
  battleResult: BattleResultType;
}

/** 大会の1試合 */
export interface TournamentMatch {
  /** 試合インデックス */
  matchIndex: number;
  /** 参加者1のID */
  participant1Id: string;
  /** 参加者2のID */
  participant2Id: string;
  /** 試合結果（未実施の場合undefined） */
  result?: TournamentMatchResult;
  /** ラウンド番号（トーナメント用: 0=準々決勝, 1=準決勝, 2=決勝） */
  round?: number;
}

/** 大会全体の状態 */
export interface TournamentState {
  /** 大会種類 */
  mode: TournamentMode;
  /** 参加者一覧 */
  participants: TournamentParticipant[];
  /** 全試合一覧 */
  matches: TournamentMatch[];
  /** 現在の試合インデックス */
  currentMatchIndex: number;
  /** 大会の進行状態 */
  phase: TournamentPhase;
  /** CPU共通AIレベル */
  aiLevel: AILevel;
}
